import React, {Component} from 'react';
import {Container} from "reactstrap";
import BackComponent from '../../components/BackComponent';
import {connect} from 'react-redux';
import FormComponent from "../../components/Task/TaskFormComponent.js";
import {getTaskDetails, updateTask} from "../../actions/taskActions";
import Swal from "sweetalert2";
import moment from "moment";


const mapStateToProps = (state) => {
    return {
        getAllUsers: state.users.getAllUsers ? state.users.getAllUsers : JSON.parse(localStorage.getItem('allUsers')),
        getAllCustomers: state.customers.getAllCustomers ? state.customers.getAllCustomers : JSON.parse(localStorage.getItem('allCustomers')),
        getTaskDetail: state.tasks.getTaskDetail,
        getResponDataTask: state.tasks.getResponDataTask,
        errorResponDataTask: state.tasks.errorResponDataTask,

    };
};

 class EditTaskContainer extends Component {

     componentDidMount() {
         this.props.dispatch(getTaskDetails(this.props.match.params.id));
     }

     handleSubmit(data){
         data.date = new Date(data.date).toISOString();

         if(data.user_id){
             data.user_id = data.user_id?.value;
         }

         {this.props.getAllUsers.map((user) => {
                 if(user._id == data.user_id){
                     data.user_firstname = user.firstname ? user.firstname : '';
                     data.user_lastname = user.lastname ? user.lastname : '';
                 }
             }
         )}

         if(data.customer_id){
             data.customer_id = data.customer_id?.value;
         }
         {this.props.getAllCustomers.map((customer) => {
                 if(customer._id == data.customer_id){
                     data.customer_firstname = customer.firstname ? customer.firstname : '';
                     data.customer_lastname = customer.lastname ? customer.lastname : '';
                 }
             }
         )}
         this.props.dispatch(updateTask(data, this.props.match.params.id))
     }
    render() {
        if(this.props.getResponDataTask || this.props.errorResponDataTask) {
            if (this.props.errorResponDataTask) {
                Swal.fire(
                    "Echec ! ",
                    this.props.errorResponDataTask,
                    "error"
                );
            } else {
                Swal.fire({
                    title: "Actions modifiée !",
                    icon :"success"
                }).then((result) => {
                    if(result.isConfirmed){
                        window.history.back();
                    }
                });
            }
        }

        return (
            <Container>
                <BackComponent />
                <h1>Modifier la tâche {this.props.getTaskDetail.type}</h1>
                <FormComponent onSubmit={(data) => this.handleSubmit(data)} />
            </Container>
        )
    }
}

export default connect(mapStateToProps,null)(EditTaskContainer)